module.exports = __webpack_public_path__ + "img/Weapon_256.126f0ca4.png";